import script from "./AllocationShareBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AllocationShareBar.vue?vue&type=script&setup=true&lang=js"

import "./AllocationShareBar.vue?vue&type=style&index=0&id=e9bb3546&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9bb3546"]])

export default __exports__